module.exports = __webpack_public_path__ + "media/assets/images/blog/sysadm_servers-739bc97aa0b74a44443dc874ee0bf6a9.jpeg";